<template lang="pug" src="./custom-get-start-financial.pug"></template>

<script>
import Icon from 'components/icon/icon'
import Intro from 'components/block/block-intro/block-intro'

export default {
  data () {
    return {
      top: 120
    }
  },
  props: ['props'],
  components: {
    Icon,
    Intro
  },
  methods: {
    fadeUp (i) {
      this.$refs.icon[i].classList.add('slide-in')
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-get-start-financial.vue?4a7bc6d1